export default __webpack_public_path__ + "static/media/back@2x.1f99fb66.png";